import { Box, Stack } from '@mui/material';
import React from 'react';

type PinDotsProps = {
  filledColor: string;
  enteredPin: string;
};

const PinDots: React.FC<PinDotsProps> = (props) => {
  const { filledColor, enteredPin } = props;

  const renderDot = (filled: boolean) => {
    return (
      <Box sx={{ position: 'relative' }}>
        <Box sx={{ border: '2px solid ' + filledColor, padding: '25px', borderRadius: '30px', margin: '6px' }}>
          <img
            style={{ position: 'absolute', left: '17px', top: '21px', display: filled ? 'block' : 'none' }}
            src={'images/5Element.png'}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Stack direction="row" spacing={0.75}>
      {[0, 1, 2, 3].map((index) => (
        <React.Fragment key={index}>{renderDot(index < enteredPin.length)}</React.Fragment>
      ))}
    </Stack>
  );
};

PinDots.displayName = 'PinDots';
export default React.memo(PinDots);
